module.exports = __webpack_public_path__ + "images/Money_hover.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Money_hover.png
// module id = 389
// module chunks = 0 1